<template>
  <v-container>
    <main-header-plat-a />
    <main-header-plat-b :navBItems="schema.navBItems" />
    <v-row class="d-flex justify-center fluid flex-sm-wrap flex-lg-nowrap">
      <v-col xs="12" sm="12" lg="5">
        <v-card-pro-patient-a-reg-1
          :cardRegPat1Items="schema.cardRegPat1Items"
          :schemaFormReg1="schema.schemaFormReg1"
          :modelReg1="modelFormReg1"
          :handleEvents="handleEvents"
          :dialogAddPatientPin="schema.dialogAddPatientPin"
        />
      </v-col>
      <v-divider vertical class="mx-7" v-show="$vuetify.breakpoint.lgAndUp"></v-divider>
      <v-col xs="12" sm="11" lg="7">
        <v-card-pro-patient-a-reg-2
          :cardRegPat2Items="schema.cardRegPat2Items"
          :schemaFormReg2="schema.schemaFormReg2"
          :modelReg2="modelFormReg2"
          :handleEvents="handleEvents"
          :save2="save2"
        />
        <v-dialog v-model="dialog" max-width="590">
          <v-card>
            <v-card-title class="text-h6 justify-center ml-n1">Código del Paciente Generado</v-card-title>
            <v-card-text class="mb-0 text-body-1">
              Este código será el identificador del paciente dentro de la plataforma. <br>
              Por favor, regístrelo y consérvelo junto con los datos personales del paciente.
              <span class="d-flex justify-center text-h5 mb-9 black--text">
                {{ patientsNpatTotal }}
              </span>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <v-snack-bar :snackbar="snackbar" />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderPlatA from '@/components/includes/MainHeaderPlatA.vue';
import MainHeaderPlatB from '@/components/includes/MainHeaderPlatB.vue';
import VCardProPatientAReg1 from '@/components/base/VCardProPatientAReg1.vue';
import VCardProPatientAReg2 from '@/components/base/VCardProPatientAReg2.vue';
import VSnackBar from '@/components/base/VSnackBar.vue';

export default {
  name: 'ProPatientsAPage',
  components: {
    MainHeaderPlatA,
    MainHeaderPlatB,
    VCardProPatientAReg1,
    VCardProPatientAReg2,
    VSnackBar,
  },
  data() {
    return {
      modelFormReg1: {},
      modelFormReg2: {},
      dialog: false
    };
  },
  mounted() {
    this.loadSchema();
  },
  computed: {
    ...mapGetters('proPatientsAPage', ['schema', 'data1', 'status', 'message', 'patientsNpatTotal']),
    ...mapGetters('notifications', ['snackbar']),
  },
  methods: {
    ...mapActions('proPatientsAPage', ['loadSchema']),
    ...mapActions('notifications', ['triggerSnackbar']),

    handleEvents() {},

    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    async save2() {
      let modelForm = this.modelFormReg2;

      if (Object.keys(modelForm).length !== 0) {
        if (!modelForm) {
          return;
        }

        if (modelForm.users_first_surname) {
          modelForm.users_first_surname = modelForm.users_first_surname.toUpperCase();
        }

        if (modelForm.users_second_surname) {
          modelForm.users_second_surname = modelForm.users_second_surname.toUpperCase();
        }

        if (modelForm.users_first_name) {
          modelForm.users_first_name = this.capitalize(modelForm.users_first_name);
        }

        if (modelForm.users_second_name !== null && modelForm.users_second_name !== undefined) {
          modelForm.users_second_name = this.capitalize(modelForm.users_second_name);
        } else {
          modelForm.users_second_name = null;
        }

        if (modelForm.users_third_name !== null && modelForm.users_third_name !== undefined) {
          modelForm.users_third_name = this.capitalize(modelForm.users_third_name);
        } else {
          modelForm.users_third_name = null;
        }

        this.$store.dispatch('proPatientsAPage/save2', modelForm).then(
          () => {
            this.reload();
            this.snackbarOpen();
            this.dialog = true;
          },
          () => {
            this.reload();
            this.snackbarOpen();
          }
        );
      }
    },
    reload() {
      this.modelFormReg1 = {};
      this.modelFormReg2 = {};
    },
    snackbarOpen() {
      this.snackbar.visible = false;
      if (this.status === 'success') {
        this.snackbar.visible = true;
        this.snackbar.content = this.message;
      } else if (this.status === 'error') {
        this.snackbar.visible = true;
        this.snackbar.content = this.message;
      }
    },
  },
};
</script>
